<template lang="pug">

  modal(ref="modal")
    template(slot="title")
      slot(name="title")

    form.form-shared#new_comment(slot="body")
      slot(name="body")
      form-errors(:errors="errors")
      fieldset
        .form-group.required.p-0
          label.form-label Sujet
          input.form-control(type="text" v-model="mutableComment.attributes.subject" data-is-input-smooth)

        .form-group.required.p-0
          .form-label.text-left
            label Temoignage
          .form-controls
            textarea(rows="8" v-model="mutableComment.attributes.description" class="form-control", placeholder="Merci de soigner votre écriture pour rédiger votre témoignage ; vous allez être lus par plusieurs milliers de lecteurs ! (seul votre prénom sera visible)")

        div(v-if='!user')
          .form-group.required.p-0
            label.form-label Prénom
            input.form-control(type="text" name="firstname" v-model="mutableComment.attributes.firstname" data-is-input-smooth required)

          .form-group.required.p-0
            label.form-label Email
            input.form-control(type="text" name="email" v-model="mutableComment.attributes.email" data-is-input-smooth required)


          .form-group.row
            .form-label Civilité
            .form-controls
              .form-check.form-check-inline
                input(type="radio" id="male" value="male" v-model="mutableComment.attributes.gender")
                label.form-check-label.ml-2(for="male") Homme
              .form-check.form-check-inline
                input(type="radio" id="female" value="female" v-model="mutableComment.attributes.gender")
                label.form-check-label.ml-2(for="female") Femme
        .form-group.row.required
          span.italic Le site reflexosteo.com propose gratuitement un service de diffusion de témoignages personnels dans le domaine de l’ostéopathie et la santé. Le contenu des témoignages est sous votre responsabilité. Cet espace n’est pas un moyen d’obtenir un diagnostic médical ni d’obtenir un RDV avec un ostéopathe. Cliquez ici pour obtenir un RDV avec un ostéopathe proche de chez vous.

    .col-md-10.col-12.p-0.d-flex.justify-content-between.m-auto(slot="footer")
      .text-muted.col-md-9.col-8 Les champs marqués d'un * sont obligatoires
      button(class="btn btn-primary"  v-on:click.prevent='submitCommentForm') Témoigner

</template>

<script>
  /* eslint no-undef: 0 */
  import FormErrors from '@sharedComponents/FormErrors'
  import axios from 'axios'

  export default {
    components: {
      FormErrors,
      Modal: () => import('@sharedComponents/Modal')
    },

    props: {
      postId: {
        type: String,
        required: true
      },
      user: Boolean
    },

    data () {
      return {
        mutableComment: {
          attributes: {
            id: null,
            firstname: null,
            email: null,
            subject: null,
            gender: null,
            description: null
          }
        },
        token: null,
        recaptcha: null,
        errors: []
      }
    },

    methods: {
      submitCommentForm () {
        this.errors = []

        if (!this.mutableComment.attributes.firstname && !this.user) {
          this.errors.push("Le prénom est obligatoire.")
        }
        if (!this.mutableComment.attributes.email && !this.user) {
          this.errors.push('Le nom est obligatoire.')
        }
        if (this.errors.length) return
        const postId = this.postId
        const mutableCommentAttributes = this.mutableComment.attributes
        grecaptcha.ready(function () {
          grecaptcha.execute('6Ldfi6YaAAAAAObA7qb4lbB8ayPZ9wGfRr88z3yn', {action: 'create_comments'}).then(function (token) {
            axios.post(`/blog-sante-bien-etre/${postId}/comments`, {
              comment: mutableCommentAttributes,
              "g-recaptcha-response-data": {
                create_comments: token
              }
            }).then(() => {
              location.reload()
            })
              .catch((error) => {
                self.errors = error.response.data
              })
          })
        })
      },

      show () { this.$refs.modal.show() },
      hide () { this.$refs.modal.hide() }
    }
  }
</script>
